import { deepDive } from "@/mocks/critter";

export default function DeepDive() {
  return (
    <section id="deep" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-3xl">
          <p className="font-label text-[11px] uppercase tracking-[0.25em] text-accent-700">
            / {deepDive.kicker}
          </p>
          <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
            {deepDive.title}
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-foreground-600 md:text-base">
            {deepDive.dek}
          </p>
        </div>

        <div className="relative mt-9 overflow-hidden rounded-lg">
          <img
            src={deepDive.img}
            alt={deepDive.alt}
            className="h-[260px] w-full object-cover object-top md:h-[440px]"
          />
          <div className="absolute inset-x-0 top-0 flex flex-wrap gap-2 bg-gradient-to-b from-background-950/60 to-transparent p-4">
            {deepDive.highlights.slice(0, 2).map((h) => (
              <span
                key={h}
                className="inline-flex items-center gap-1 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800"
              >
                <i className="ri-checkbox-circle-line text-accent-700"></i>
                {h}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-10 lg:grid-cols-[1fr_300px]">
          {/* body */}
          <article className="max-w-2xl">
            {deepDive.body.map((p, i) => (
              <div key={i} className="mb-6 flex gap-4">
                <span className="font-label shrink-0 pt-1 text-sm font-bold text-accent-600">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-[15px] leading-[1.9] text-foreground-700">{p}</p>
              </div>
            ))}
            <blockquote className="mt-8 border-l-2 border-primary-600 bg-primary-50 py-4 pl-5 pr-4 text-[15px] leading-relaxed text-foreground-800">
              判断一场交易值不值得，永远不要只听喊价，而要去看它背后那本不愿给你看的账。
            </blockquote>
          </article>

          {/* aside */}
          <aside>
            <div className="sticky top-32 rounded-lg border border-background-300 bg-background-50 p-6">
              <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-600">本期要点</p>
              <ul className="mt-4 space-y-3">
                {deepDive.highlights.map((h) => (
                  <li key={h} className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-700">
                    <i className="ri-record-circle-line mt-0.5 shrink-0 text-accent-500"></i>
                    {h}
                  </li>
                ))}
              </ul>
              <div className="mt-6 border-t border-dashed border-background-300 pt-5">
                <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                  <i className="ri-timer-line text-accent-600"></i> 全文约 8 分钟
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="cursor-pointer inline-flex flex-1 items-center justify-center gap-1.5 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-700 whitespace-nowrap"
                  >
                    收藏本文 <i className="ri-bookmark-line text-sm"></i>
                  </button>
                  <button
                    type="button"
                    aria-label="分享"
                    className="cursor-pointer flex h-10 w-10 items-center justify-center rounded-md bg-background-200 text-foreground-700 hover:bg-accent-200 whitespace-nowrap"
                  >
                    <i className="ri-share-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}